export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8122.5eadae5c.jpg";